import { cssVar } from 'src/app/styles/helper';
import { RadiusPropKeys } from 'src/app/styles/spacing';
import styled, { css } from 'styled-components';

export interface CoverOptions {
  autoWidth?: boolean;
  autoHeight?: boolean;
}

interface AssetWrapperProps {
  $maxWidth?: string | number;
  $type?: 'image' | 'video' | 'imageRaw';
  $radius?: RadiusPropKeys;
  $cover?: boolean;
  $coverOptions?: CoverOptions;
}

const videoStyles = css<AssetWrapperProps>`
  ${({ $cover, $coverOptions }) =>
    !$cover
      ? ''
      : css`
          ${!$coverOptions?.autoHeight && 'height: 100%;'}

          > video {
            ${!$coverOptions?.autoWidth && 'width: 100%;'}
            ${!$coverOptions?.autoHeight && 'height: 100%;'}
            object-fit: cover;
          }
        `}
`;

const imageStyles = css<AssetWrapperProps>`
  ${({ $cover, $coverOptions }) =>
    $cover
      ? css`
          ${!$coverOptions?.autoWidth && 'width: 100%;'}
          ${!$coverOptions?.autoHeight && 'height: 100%;'}
          object-fit: cover;

          img,
          .gatsby-image-wrapper {
            ${!$coverOptions?.autoWidth && 'width: 100%;'}
            ${!$coverOptions?.autoHeight && 'height: 100%;'}
            object-fit: cover;
          }
        `
      : ''}
`;

const imageRawStyles = css<AssetWrapperProps>`
  ${({ $cover, $coverOptions }) =>
    !$cover
      ? css`
          img {
            width: 100%;
            height: auto;
          }
        `
      : css`
          ${!$coverOptions?.autoWidth && 'width: 100%;'}
          ${!$coverOptions?.autoHeight && 'height: 100%;'}
          object-fit: cover;
          display: grid;

          > img {
            ${!$coverOptions?.autoWidth && 'width: 100%;'}
            ${!$coverOptions?.autoHeight && 'height: 100%;'}
            object-fit: cover;
          }
        `}
`;

export const AssetWrapperContainer = styled.div<AssetWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: fit-content;
  border-radius: ${(props) => (props.$radius ? cssVar(props.$radius) : 'unset')};
  max-width: ${(props) => {
    if (typeof props.$maxWidth === 'number') {
      return `${props.$maxWidth}px`;
    }

    return props.$maxWidth || '100%';
  }};
  ${({ $type }) => ($type === 'video' ? videoStyles : '')}
  ${({ $type }) => ($type === 'imageRaw' ? imageRawStyles : '')}
  ${({ $type }) => ($type === 'image' ? imageStyles : '')}
`;
